import React from 'react';
import { useLocalization } from 'gatsby-theme-i18n';

export function withLocale(Component) {
  return function getComponent(props) {
    const { locale, config } = useLocalization();
    return (
      <Component locale={locale} i18nConfig={config} {...props} />
    );
  };
}

export function filterEdgesByLocale(edges, locale) {
  return edges?.filter((el) => el?.node?.fields?.locale === locale) || [];
}

export function filterByLocale(data, locale) {
  return filterEdgesByLocale(data?.allMdx?.edges, locale);
}

export function ease(value) {
  return (Math.cos((value + 1) * Math.PI) * 0.5) + 0.5;
}

export function generateGradientSteps(colorFn, valuesFrom, valuesTo, units, easeFn = ease, from = 0, to = 100, steps = 16) {
  const lines = [];
  for (let i = 0; i < steps; i += 1) {
    const ratio = i / (steps - 1);
    const percentage = (ratio * (to - from)) + from;
    const values = valuesFrom.map((fromValue, idx) => {
      const toValue = valuesTo[idx];
      const easedRatio = easeFn(ratio);
      return (easedRatio * (toValue - fromValue)) + fromValue;
    });
    const stringifiedValues = values.map((value, idx) => `${value}${units[idx]}`).join(',');
    lines.push(`${colorFn}(${stringifiedValues}) ${percentage}%`);
  }
  return lines.join(',');
}

export function bubbleSvg(color, rotation = 0) {
  const svg = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 84 84" style="transform: rotate(${rotation}deg)">
    <defs>
      <style>
        rect { fill: ${color}; }
      </style>
    </defs>
    <rect x="10" y="10" width="64" height="64" rx="12" ry="12"/>
  </svg>`;
  return `url(data:image/svg+xml;base64,${btoa(svg)})`;
}

export function removeCookies() {
  const res = (typeof window !== 'undefined') ? document.cookie : '';
  const cookies = res.split(';');
  for (let i = 0; i < cookies.length; i += 1) {
    const [key] = cookies[i].split('=');
    document.cookie = `${key} =; path=/; expires = Thu, 01 Jan 1970 00:00:00 UTC`;
    document.cookie = `${key} =; path=/en; expires = Thu, 01 Jan 1970 00:00:00 UTC`;
  }
}

export default {
  withLocale,
  filterEdgesByLocale,
  filterByLocale,
  ease,
  generateGradientSteps,
  bubbleSvg,
  removeCookies,
};
